export enum PainSeverity {
    NONE = "NONE",
    MILD = "MILD",
    MODERATE = "MODERATE",
    SEVERE = "SEVERE",
}
